import { Component, Output, OnInit, Input } from '@angular/core';
import Swal from 'sweetalert2';
declare var jQuery: any;


@Component({
  selector: 'modal-dialog',
  //selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],

})
/** Modal component*/
export class ModalComponent {


  @Input() modalId: string = 'modal-dialog';

  /** Modal ctor */
  constructor() {
    (function ($) {
      $(document).ready(function () {
        jQuery('.ModalFront').appendTo('#ModalParent');
      });
    })(jQuery);

  }

  public open() {
    (function ($) {
      $(document).ready(function () {
        jQuery('.ModalFront').appendTo('#ModalParent');
      });
    })(jQuery);
  }

}

